module.exports = __webpack_public_path__ + "media/hearts/blue-heart-3410b833.svg";